<template>
  <div>
    <div class="header bg-card py-xl-5">
      <div class="container py-5">
        <div class="header-body text-center py-5">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8">
              <div class="text-center">
                <img
                  src="~rhomtrip_assets/src/img/brand/logo-rhomtrip-mobility-suppliers.png"
                  class="img-fluid"
                />
              </div>

              <h1 class="title-view my-4">Page not found.</h1>
              <p class="text-lead">
                Don't worry though, we have plenty of other pages to explore
              </p>
              <base-button
                class="btn btn-outline-secondary min-button"
                @click="goToPreviousPage()"
                v-if="sesion !== null"
                ><i class="flaticon-left"></i> Back</base-button
              >
              <router-link
                v-else
                to="/signin"
                class="btn btn-outline-secondary min-button"
                ><i class="flaticon-left"></i> Back</router-link
              >
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon class="fill-default" points="2560 0 2560 100 0 100" />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { goBack } from "../../helpers/commons.helpers";
export default {
  name: "not-found",
  data() {
    return {
      name: ""
    };
  },
  created() {
    this.getSesion();
  },
  methods: {
    goToPreviousPage() {
      goBack(this);
    },
    ...mapMutations(["setSesion", "setLoad"]),
    ...mapActions(["getSesion"])
  },
  computed: {
    ...mapGetters(["sesion"])
  }
};
</script>
